import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { Listado } from "./components/Listado";
import TabBar from "rc-tabs/lib/TabBar";
import { Link } from "react-router-dom";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import "./styles/Paletizaciones.css";
import { ESTADOS_PRODUCCION } from "../../../../../../../../utility/constants";

class Paletizaciones extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    navigateToPaletizacionForm = (idPaletizacion) => {
        this.props.history.push(
            `/produccion-v2/crear-paletizacion/${idPaletizacion}`,
        );
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="produccion_activo"
                    titulo="Producción Sólidos"
                    subtitulo="Paletizaciones"
                    noBorder
                >
                    <Listado
                        regresar={this.regresar}
                        navigateToPaletizacionForm={
                            this.navigateToPaletizacionForm
                        }
                    />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(Paletizaciones);
